export default {
  'profile.verified': 'Terverifikasi',
  'profile.unverified': 'Belum diverifikasi',
  'profile.refresh': 'Refresh',
  'profile.name': 'Nama',
  'profile.getCode': 'Dapatkan Kode',
  'profile.codeTip': 'Masukkan kode',
  'profile.verifyCode': 'Kode Verifikasi',
  'profile.phoneChange': 'Ubah Nomor Telepon',
  'profile.checkPhone': 'Verifikasi Telepon Saat Ini',
  'profile.bindNewPhone': 'Ikat Telepon Baru',
  'profile.nuxt': 'Selanjutnya',
  'profile.changeSuccess': 'Berhasil diubah!',
  'profile.firstNameTip': 'Masukkan Nama Depan',
  'profile.lastNameTip': 'Masukkan Nama Belakang',
  'profile.emailChange': 'Ubah Email',
  'profile.checkEmail': 'Verifikasi Email Saat Ini',
  'profile.bindNewEmail': 'Ikat Email Baru',
  'profile.bindEmailTip': 'Masukkan Email Baru',
  'app.profile': 'Pusat Pribadi',
  'app.profile.account': 'Informasi Akun',
  'app.profile.account.save': 'Simpan',
  'app.profile.account.account': 'Akun',
  'app.profile.account.password': 'Kata Sandi',
  'app.profile.account.password.update': 'Pembaruan kata sandi terakhir pada',
  'app.profile.account.password.reset': 'Reset Kata Sandi',
  'app.profile.account.name.first': 'Nama Depan',
  'app.profile.account.name.last': 'Nama Belakang',
  'app.profile.account.name.phone': 'Telepon Seluler',
  'app.profile.account.name.phone.tip':
    'Kami mungkin menggunakan nomor telepon ini untuk mengirimkan pesan tentang peristiwa keamanan, tagihan, dan peringatan bisnis',
  'app.profile.account.name.url': 'Alamat callback',
  'app.profile.account.name.urlTip':
    'Harus dimulai dengan http:// atau https://, port khusus tidak didukung, dan segmen jaringan pribadi dengan alamat IP 10.0.0.0/8, 172.16.0.0/12, dan 192.168.0.0/16 tidak didukung.',
  'app.profile.account.name.verification': 'Verifikasi',
  'app.profile.account.name.verification.tip[1]': 'Lulus',
  'app.profile.account.name.verification.tip[2]': 'Gagal',
  'app.profile.developer': 'Informasi Pengembang',
  'app.profile.developer.remark': 'Terbatas pada panggilan API',
  'app.profile.developer.label[1]': 'ID Pengembang (DevKey)',
  'app.profile.developer.label[2]': 'API DevSecret',
  'app.profile.developer.copy': 'Lihat dan salin',
  'app.profile.developer.reset': 'Reset',
  'app.profile.developer.reset.tip': 'Tip',
  'app.profile.developer.reset.tip.content':
    'Perubahan Dev Secret akan mempengaruhi push API, memerlukan pemanggil untuk mengubah kode panggilan',
  'app.profile.developer.reset.tip.sure': 'Konfirmasi',
  'app.profile.developer.reset.tip.cancel': 'Nanti',
  'app.profile.developer.copy.success': 'Salin berhasil',
  'app.profile.developer.reset.success': 'Reset berhasil',
  'app.profile.single': 'Single Sign-on',
  'app.profile.single.tip[1]': 'Tingkatkan keamanan dan kurangi risiko akun',
  'app.profile.single.tip[2]':
    'Hindari pembuatan akun yang sering terjadi ketika karyawan menggunakan sistem bisnis yang berbeda',
  'app.profile.single.tip[3]':
    'Sederhanakan autentikasi dengan menggunakan sistem akun karyawan internal',
  'app.profile.single.enable': 'Hubungi Kami',
  'app.profile.single.title': 'Permintaan Bisnis',
  'app.profile.single.subject': 'Subjek',
  'app.profile.single.subject.value': 'Aktifkan Single Sign-on untuk akun saya',
  'app.profile.single.content':
    'Hai, saya ingin mengaktifkan Single Sign On. Silakan hubungi saya. Terima kasih.',
  'app.profile.single.subject.validator': 'Silakan masukkan subjek Anda',
  'app.profile.single.subject.doc': 'Aktifkan Single Sign-on untuk akun saya',
  'app.profile.single.message': 'Pesan',
  'app.profile.single.message.validator': 'Silakan masukkan pesan Anda',
  'app.profile.single.submit': 'Kirim',
  'app.profile.single.submit.success': `Berhasil dikirim, menunggu balasan email administrator`,
  'app.profile.account.deletion': 'Penghapusan Akun',
  'app.profile.account.deletion.warn':
    'Ketika Anda menghapus akun Anda, akun Anda dengan informasi pengguna, informasi bisnis, informasi pesanan, dan data lain yang terkait akan dihapus secara permanen. Setelah akun Anda dihapus, Anda tidak akan dapat memulihkan akun atau data Anda.',
  'app.profile.account.deletion.action': 'Hapus Akun Saya',
  'app.profile.delete.title': 'Hapus akun',
  'app.profile.delete.content':
    'Peringatan! Menghapus akun Anda tidak dapat dibatalkan. Ini akan secara permanen menghapus data dan informasi seperti pengguna, bisnis, saldo, tagihan, pesanan, dan kepentingan akun ini, dan semua layanan terkait akan dihentikan.',
  'app.profile.delete.content2':
    'Mungkin Anda dapat mencapai tujuan Anda dengan "memodifikasi alamat email akun" atau "memberikan izin peran kepada anggota organisasi." Disarankan untuk mencoba terus menggunakan akun kecuali benar-benar diperlukan.',
  'app.profile.delete.warn':
    'Ketika ada tambahan yang harus dibayar, akun Anda tidak dapat dihapus!',
  'app.profile.delete.cancel': 'Batal',
  'app.profile.delete.next': 'Selanjutnya',
  'app.profile.delete.delete': 'Hapus',
  'app.profile.delete.confirm': 'Konfirmasi penghapusan',
  'app.profile.delete.confirm.content':
    'Sebelum penghapusan akun Anda berlaku, kami akan memverifikasi akun Anda sebagai berikut. Silakan temukan kode verifikasi di email.',
  'app.profile.delete.confirm.send': 'Kirim kode verifikasi',
  'app.profile.delete.confirm.send.resend': 'Kirim ulang kode verifikasi',
  'app.profile.delete.confirm.resend': 'Kirim ulang',
  'app.profile.delete.confirm.rule': 'Silakan masukkan verifikasi yang benar',
  'app.profile.delete.confirm.code.title': 'Kode Verifikasi Email',
  'app.profile.delete.confirm.code.desc':
    'Untuk memverifikasi identitas Anda dan memastikan keamanan akun, silakan berikan kode verifikasi yang diterima di email Anda currentAccount.email',
  'app.profile.delete.confirm.reason.title': 'Alasan Penghapusan',
  'app.profile.delete.confirm.reason.desc': 'Informasi ini membantu kami meningkatkan produk kami',
  'app.profile.delete.confirm.reason.placeholder': 'Pilih alasan',
  'app.profile.delete.confirm.reason.select1': 'Menghapus akun uji',
  'app.profile.delete.confirm.reason.select2': 'Beralih ke akun lain',
  'app.profile.delete.confirm.reason.select3': 'Tidak lagi tertarik menggunakan layanan EngageLab',
  'app.profile.delete.confirm.reason.select4': 'Lainnya',
  'app.profile.reset.title': 'Reset Kata Sandi',
  'app.profile.reset.password.old': 'Kata Sandi Lama',
  'app.profile.reset.password.old.placeholder': 'Silakan masukkan kata sandi lama',
  'app.profile.reset.password.new': 'Kata Sandi Baru',
  'app.profile.reset.password.new.placeholder': 'Silakan masukkan kata sandi baru',
  'app.profile.reset.password.confirm': 'Konfirmasi Kata Sandi',
  'app.profile.reset.password.confirm.placeholder': 'Silakan konfirmasi kata sandi Anda',
  'app.profile.reset.cancel': 'Batal',
  'app.profile.reset.confirm': 'Konfirmasi',
  'app.profile.rule.blank': 'Bidang ini tidak boleh kosong',
  'app.profile.reset.new.rule[0]': 'Berisi setidaknya 8 karakter',
  'app.profile.reset.new.rule[1]': 'Harus berisi huruf besar dan kecil pada saat yang sama',
  'app.profile.reset.new.rule[2]': 'Berisi setidaknya satu angka (0-9) atau satu simbol',
  'app.profile.reset.confrim.rule[0]': 'Kata sandi tidak cocok',
  'app.profile.reset.old.rule[0]': 'Kata sandi tidak konsisten',
  'app.profile.reset.success': 'Kata sandi Anda telah direset',
  'app.profile.aws.title': 'Pesanan Amazon',
  'app.profile.aws.subtitle':
    'Akun EngageLab Anda terhubung ke akun Amazon Anda. Tautkan pesanan Amazon Anda ke layanan EngageLab di sini untuk menikmati manfaat VIP.',
  'app.profile.aws.account': 'Nomor Akun Amazon:',
  'app.profile.aws.btn': 'Kelola',
  'app.profile.human.code.loadingTip': 'Harap tunggu...',
  'app.profile.human.code.placeholder': 'Silakan masukkan kode verifikasi',
  'app.profile.human.check.tip': 'Silakan selesaikan verifikasi manusia terlebih dahulu.',
  'app.profile.human.check.error': 'Verifikasi manusia gagal, silakan coba lagi.',
  'app.profile.sso.title': 'Layanan Konfigurasi SSO',
  'app.profile.sso.empty.title': 'Anda belum mengonfigurasi SSO apa pun',
  'app.profile.sso.empty.description':
    'Setelah mengonfigurasi SSO, pengguna, anggota, dan mitra bisnis di bawah organisasi yang dikonfigurasi dapat mengakses dengan aman semua yang mereka butuhkan untuk melakukan pekerjaan terbaik mereka, serta pengalaman login yang intuitif.',
  'app.profile.sso.empty.configure': 'Konfigurasi SSO',
  'app.profile.sso.empty.title2': 'Tidak Ada Manfaat SSO',
  'app.profile.sso.empty.description2':
    'Organisasi Anda belum mengaktifkan manfaat SSO. Silakan hubungi penjualan untuk mengaktifkan SSO sebelum mengonfigurasi.',
  'app.profile.sso.empty.contact': 'Hubungi Kami',
  'app.profile.sso.empty.contact.content': 'Saya ingin membuat SSO',
  'app.profile.sso.list.configure': 'Konfigurasi SSO',
  'app.profile.sso.list.authorizedOrg': 'Organisasi yang Diberikan Izin',
  'app.profile.sso.list.benefitStatus': 'Status Manfaat',
  'app.profile.sso.list.authorizedOrgLong':
    'Organisasi yang Diberikan Izin Organisasi yang Diberikan Izin Organisasi yang Diberikan Izin Organisasi yang Diberikan Izin Organisasi yang Diberikan Izin Organisasi yang Diberikan Izin Organisasi yang Diberikan Izin',
  'app.profile.sso.list.edit': 'Edit',
  'app.profile.sso.list.authorize': 'Berikan Izin',
  'app.profile.sso.list.delete': 'Hapus',
  'app.profile.sso.list.deleteConfirm.title': 'Konfirmasi hapus layanan SSO {name}?',
  'app.profile.sso.list.deleteConfirm.content':
    'Setelah menghapus layanan SSO, organisasi yang diizinkan oleh layanan ini tidak akan lagi mendukung login SSO, tautan login akan tidak valid, dan mereka akan menerima email untuk berhenti menggunakan login SSO.',
  'app.profile.sso.list.deleteSuccess': 'Hapus berhasil',
  'app.profile.sso.list.confirm.modify.title': 'Konfirmasi modifikasi otorisasi layanan SSO?',
  'app.profile.sso.list.confirm.modify.content.add':
    'Organisasi yang baru diizinkan akan menerima pengingat email yang mencakup tautan login SSO untuk mereka masuk.',
  'app.profile.sso.list.confirm.modify.content.remove':
    'Organisasi yang diizinkan yang dibatalkan akan menerima pengingat email yang mencakup tautan login alternatif untuk mereka masuk.',
  'app.profile.sso.option.step1': 'Konfigurasi IdP',
  'app.profile.sso.option.step2': 'Pengembalian Sumber Data',
  'app.profile.sso.option.step3': 'Berikan Izin Organisasi',
  'app.profile.sso.option.step4': 'Verifikasi',
  'app.profile.sso.option.continue': 'Lanjutkan',
  'app.profile.sso.option.prev': 'Sebelumnya',
  'app.profile.sso.option.back': 'Kembali',
  'app.profile.sso.option.submit': 'Kirim',
  'app.profile.sso.option.save': 'Simpan dan Verifikasi',
  'app.profile.sso.step1.title': 'Konfigurasi Engagelab di IdP',
  'app.profile.sso.step1.description':
    'Single Sign-On (SSO), Anda pertama-tama perlu menambahkan Engagelab sebagai aplikasi di Identity Provider (IdP) Anda. Silakan hubungi administrator IdP organisasi Anda untuk menambahkan konfigurasi aplikasi di bawah akun Anda.',
  'app.profile.sso.step1.serviceType': 'Jenis Layanan SSO',
  'app.profile.sso.step1.guideText':
    'Anda dapat menggunakan token berikut untuk berkolaborasi dengan administrator IdP organisasi Anda:',
  'app.profile.sso.step1.copy': 'Salin',
  'app.profile.sso.step1.confirmTip':
    'Saya konfirmasi bahwa informasi aplikasi Engagelab telah diperbarui di IdP Anda',
  'app.profile.sso.step1.infoText': `Saya sedang menyiapkan SSO untuk Engagelab, dan saya memerlukan bantuan untuk menyiapkan Engagelab sebagai aplikasi di penyedia identitas kami.

Berikut adalah informasi yang disediakan Engagelab untuk menyiapkan aplikasi:

Entity ID:643e77b90116033eef7e325b001
ACS URL: https://www.engagelab.com/accounts/signin/callback?connection=643e77b90116033eef7e325b001
Login URL：https://www.engagelab.com/accounts/signin-sso
Logout URL：https://www.engagelab.com/api/console/account/login/out

Setelah aplikasi Engagelab disiapkan di IdP kami, silakan kirimkan informasi berikut dari IdP kepada saya untuk menyelesaikan pengaturan SSO di Engagelab:

X.509 certificate:`,
  'app.profile.sso.step2.title': 'Masukkan Data Pengembalian IdP',
  'app.profile.sso.step2.description':
    'Sekarang Anda telah menyiapkan aplikasi Engagelab di Identity Provider Anda dan memiliki informasi yang diperlukan, silakan masukkan informasi berikut dari aplikasi IdP di sini.',
  'app.profile.sso.step2.serviceName': 'Nama Layanan SSO',
  'app.profile.sso.step2.serviceNamePlaceholder':
    'Silakan masukkan nama yang menjelaskan layanan SSO untuk memudahkan pembedaan dalam daftar layanan',
  'app.profile.sso.step2.certificate': 'Sertifikat x509',
  'app.profile.sso.step2.certificatePlaceholder': 'Silakan salin konten sertifikat base64 di sini',
  'app.profile.sso.step2.loginUrl': 'URL Login IdP',
  'app.profile.sso.step2.loginUrlPlaceholder': 'Silakan masukkan URL login Identity Provider',
  'app.profile.sso.step2.logoutUrl': 'URL Logout IdP',
  'app.profile.sso.step2.logoutUrlPlaceholder': 'Silakan masukkan URL logout Identity Provider',
  'app.profile.sso.step3.title': 'Berikan Izin IdP ke Organisasi',
  'app.profile.sso.step3.description':
    'Silakan berikan izin layanan SSO ini kepada organisasi yang telah Anda buat. Anggota organisasi dapat masuk ke Engagelab menggunakan Identity Provider (IdP) yang dikonfigurasi.',
  'app.profile.sso.step3.selectOrg': 'Pilih Organisasi',
  'app.profile.sso.step3.contactBusiness': 'Hubungi Bisnis',
  'app.profile.sso.step3.noBenefitTip': 'Organisasi saat ini tidak memiliki hak dan tidak tersedia',
  'app.profile.sso.step3.saveConfirm.title':
    'Setelah mengonfigurasi layanan SSO untuk organisasi, anggota organisasi harus menggunakan login SSO untuk mengakses organisasi',
  'app.profile.sso.step3.saveConfirm.content':
    'Setelah menyimpan, semua anggota organisasi akan keluar dan menerima email yang memerlukan login SSO',
  'app.profile.sso.step3.canAuthorize': 'Dapat Diberikan Izin',
  'app.profile.sso.step3.numLimit.title': 'Terbatas',
  'app.profile.sso.step3.numLimit.tip': 'Batas Protokol SSO Terlampaui',
  'app.profile.sso.step3.numLimit.text': 'Batas protokol SSO terlampaui, tidak tersedia',
  'app.profile.sso.step3.noBenefit.title': 'Tidak Ada Hak',
  'app.profile.sso.step3.noBenefit.text': 'Organisasi saat ini tidak memiliki hak, tidak tersedia',
  'app.profile.sso.step3.column.orgId': 'ID Organisasi',
  'app.profile.sso.step3.column.orgName': 'Nama Organisasi',
  'app.profile.sso.step3.column.memberNum': 'Jumlah Anggota',
  'app.profile.sso.step3.column.authStatus': 'Status Otorisasi',
  'app.profile.sso.step3.column.timeZone': 'Zona Waktu',
  'app.profile.sso.step3.column.createTime': 'Waktu Pembuatan',
  'app.profile.sso.step4.title': 'Verifikasi Layanan SSO',
  'app.profile.sso.step4.description':
    'Sekarang Anda telah menyelesaikan semua konfigurasi SSO, silakan akhirnya konfirmasi bahwa pengguna dapat berhasil masuk ke Engagelab menggunakan SSO.',
  'app.profile.sso.step4.loginUrl': 'URL Login SSO',
  'app.profile.sso.step4.tip': 'Tip',
  'app.profile.sso.step4.tipContent':
    'Akun yang masuk melalui tautan ini akan secara otomatis diberikan peran Default jika mereka tidak memiliki peran dalam organisasi. Anda dapat memodifikasi peran mereka setelah anggota bergabung.',
  'app.profile.sso.step4.notice': 'Harap Perhatikan',
  'app.profile.sso.step4.noticeContent':
    'Akun yang masuk melalui tautan ini akan secara otomatis diberikan peran Default jika mereka tidak memiliki peran dalam organisasi. Anda dapat memodifikasi peran mereka setelah anggota bergabung.',
  'app.profile.sso.step4.needHelp': 'Masih butuh bantuan',
  'app.profile.sso.step4.helpContent':
    'Tidak dapat masuk berhasil? Silakan merujuk ke dokumentasi untuk inspeksi.',
  'app.profile.sso.step4.viewDoc': 'Lihat Dokumentasi',
  'app.profile.sso.details.title': 'Detail Layanan SSO',
  'app.profile.sso.details.serviceDetails': 'Detail Layanan SSO',
  'app.profile.sso.details.name': 'Nama',
  'app.profile.sso.details.namePlaceholder': 'Silakan masukkan nama',
  'app.profile.sso.details.type': 'Jenis',
  'app.profile.sso.details.typePlaceholder': 'Silakan masukkan jenis',
  'app.profile.sso.details.loginLink': 'Tautan Login SSO',
  'app.profile.sso.details.loginLinkPlaceholder': 'Silakan masukkan tautan login SSO',
  'app.profile.sso.details.spConfig': 'Informasi Konfigurasi SP',
  'app.profile.sso.details.entityIdPlaceholder': 'Silakan masukkan Entity ID',
  'app.profile.sso.details.idpConfig': 'Informasi Konfigurasi IDP',
  'app.profile.sso.details.certificatePlaceholder': 'Silakan masukkan sertifikat X.509',
  'app.profile.sso.details.loginUrlPlaceholder': 'Silakan masukkan Login URL',
  'app.profile.sso.details.logoutUrlPlaceholder': 'Silakan masukkan Logout URL',
  'app.profile.sso.details.urlPlaceholder': 'Silakan masukkan URL yang benar',
  'app.profile.sso.details.certificateExpiry': 'Sertifikat akan kedaluwarsa pada {date}',
  'app.profile.sso.details.cancel': 'Batal',
  'app.profile.sso.details.save': 'Simpan',
  'app.profile.sso.details.edit': 'Edit',
  'app.profile.sso.orgSelect.title': 'Berikan Izin Organisasi',
  'app.profile.sso.orgSelect.availableOrg': 'Organisasi yang Tersedia',
  'app.profile.sso.orgSelect.serviceExpired': 'Manfaat layanan kedaluwarsa, tidak tersedia',
  'app.profile.sso.orgSelect.contactBusiness': 'Hubungi Bisnis',
  'app.profile.sso.orgSelect.authorizedService': 'Layanan yang Diberikan Izin',
  'app.profile.sso.orgSelect.serviceNameLong':
    'Nama layanan SSO nama layanan nama layanan nama layanan Nama layanan SSO nama layanan nama layanan nama layanan Nama layanan SSO nama layanan nama layanan nama layanan Nama layanan SSO nama layanan nama layanan nama layanan',
  'app.profile.sso.orgSelect.selectedOrg': 'Organisasi yang Dipilih',
  'app.profile.sso.orgSelect.noSelectedOrg':
    'Tidak ada organisasi yang dipilih, silakan pilih dari kiri',
  'app.profile.sso.orgSelect.noAvailable': 'Tidak ada organisasi yang tersedia',
  'app.profile.sso.orgSelect.authorized': 'Diberikan Izin',
  'app.profile.sso.orgSelect.cancel': 'Batal',
  'app.profile.sso.orgSelect.save': 'Simpan',
  'app.profile.sso.orgSelect.canAuthorize': 'Dapat Memberikan Izin',
  'app.profile.sso.orgSelect.otherAuthorize': 'Otorisasi Lainnya',
  'app.profile.sso.orgSelect.noBenefit': 'Tidak Ada Manfaat',
  'app.profile.sso.orgSelect.saveSuccess': 'Simpan Berhasil',
  'app.profile.sso.list.ssoServiceName': 'Nama Layanan SSO',
  'app.profile.sso.list.ssoType': 'Jenis',
  'app.profile.sso.list.ssoLoginUrl': 'Tautan Login',
  'app.profile.sso.list.authOrgList': 'Organisasi yang Diberikan Izin',
  'app.profile.sso.authorized.organizations': 'Organisasi yang Diberikan Izin',
  'app.profile.sso.benefit.status': 'Status Manfaat',
  'app.sso.no.permission.title': 'Tidak Ada Izin',
  'app.sso.no.permission.desc': 'Silakan hubungi administrator untuk izin',
  'app.sso.no.permission.logout': 'Keluar',
};
